import { useForm } from 'react-hook-form-mui';

import { useUpdateMetadataOfFile } from 'src/use-cases/internalDashboard/useFileResolution';
import { ROW_ACTION_TYPE, TUpdateValues } from './types';
import { ModalUpdateBase } from './ModalUpdateBase';
import { FormEditConfig } from './FormEditConfig';
import { useInternalDashboardSelector } from './Selector';

const defaultValues = {
  configId: '',
  extractedPage: 0,
};

export const ModalEditConfig = () => {
  const { mutateAsync: updateMetadata } = useUpdateMetadataOfFile();
  const { selectedRow, setIsActionLoading, filterParams, stopRowAction } = useInternalDashboardSelector();

  const formContext = useForm({
    defaultValues: defaultValues as TUpdateValues,
  });

  const onSubmitForm = async (values: TUpdateValues) => {
    setIsActionLoading(true);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const actionResponse = await updateMetadata({
      data: {
        pipelineId: selectedRow?.invoiceFileProcessingId,
        dataPipelineConfigId: values?.configId || '',
        extractedPage: values?.extractedPage && values?.extractedPage !== '' ? parseInt(values?.extractedPage || 0, 10) : null,
      },
      params: filterParams,
      invoiceFileProcessingId: selectedRow?.invoiceFileProcessingId,
    });

    setIsActionLoading(false);
    stopRowAction();
  };

  return (
    <ModalUpdateBase title='Edit Config' actionType={ROW_ACTION_TYPE.EDIT_CONFIG} formContext={formContext} onSubmit={onSubmitForm}>
      <>
        <p className='text-16 text-blue_grey-80'>Check the following metadata and amend if needed:</p>
        <div className='mt-20'>
          <FormEditConfig />
        </div>
      </>
    </ModalUpdateBase>
  );
};
